import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage } from '../../components/Validator';

export class RecoverPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formData: {
                email: "",
            },
            validation: {
                error: false,
                message: "Enter your Email and instructions will be sent to you!"
            }
        }
    }
    componentDidMount() {
    }
    onChange(key, value) {
        let formData = this.state.formData;
        formData[key] = value;
        this.setState({
            formData
        })
    }

    onReset() {
        if (this.state.formData.email === null || this.state.formData.email === "") {
            this.setState({
                validation: {
                    error: true,
                    message: "Please enter your email!"
                }
            })
            return;
        }
        Config.utilities.loadingFetch();

        Service.User.ResetPassword({ 'email': this.state.formData.email }).then(response => {
            if (response) {
                this.setState({ validation: response })

            }

            Config.utilities.loadingFetch();
        });
    }

    render() {
        return (
            <>

                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark"><i className="fas fa-home h2"></i></Link>
                </div>

                <div className="wrapper-page">
                    <div className="card overflow-hidden account-card mx-3">
                        <div className="bg-dark p-4 text-white text-center position-relative">
                            <h4 className="font-20 mb-4">Reset Password</h4>
                            <Link to="/login" className="logo logo-admin"><img src="assets/images/logo/logo-icon.svg" height="24" alt="logo" /></Link>
                        </div>

                        <div className="account-card-content">
                            <ErrorMessage Validation={this.state.validation} />
                                {this.state.validation.error
                                    ? ""
                                    :
                                    <div className="alert alert-success m-t-30" role="alert">
                                        {this.state.validation.message}
                                    </div>
                                }

                            <div className="form-group">
                                <label for="useremail">Email</label>
                                <input type="email" className="form-control" autoComplete="off" id="useremail" onChange={(e) => this.onChange("email", e.target.value)} value={this.state.formData.email} placeholder="Enter email" />
                            </div>

                            <div className="form-group row m-t-20 mb-0">
                                <div className="col-12 text-right">
                                    <button className="btn btn-dark w-md waves-effect waves-light" type="button" onClick={(e) => this.onReset(e)}>Reset</button>
                                </div>
                            </div>
                            <div className="form-group m-t-10 mb-0 row">
                                <div className="col-12 m-t-20">
                                    <Link to="/login"><i className="fas fa-angle-double-left"></i> Login</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="m-t-40 text-center">
                        <p>© {new Date().getFullYear()} ARTSMRKTS </p>
                    </div>
                </div>
            </>
        );
    }
}

